import AuthProvider from "./providers/auth";
import GraphQLProvider from "./providers/graphql";
import ThemeProvider from "./providers/theme";
import RouterProvider from "./providers/router";
import { IdleTimerWrapper } from "./components/organisms/IdleTimerWrapper/IdleTimerWrapper";

function AppContent() {
    return (
        <GraphQLProvider>
            <ThemeProvider>
                <IdleTimerWrapper />
                <RouterProvider />
            </ThemeProvider>
        </GraphQLProvider>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppContent />
        </AuthProvider>
    );
}

export default App;
